const config = {
    secret_key: process.env.REACT_APP_SECRET_KEY,
}
export default config
export const API_SERVER = window.location.protocol + '//' + window.location.host;

export const initializeFilterData = {
    "SearchText": "",
    "StartValue": "2",
    "SearchFieldValue": "",
    "PageSize": "10",
    "AdvanceFilter": []
}